import React from "react";

import PrimaryButton from "../../../../../components/buttons/PrimaryButton";
import { IPhoneFlowIcon, MacFlowIcon } from "../../components/flow-icons";
import { DeviceKind } from "./constants";

interface IProps {
  onSelect: (kind: DeviceKind) => void;
}

// Exclusivo de MacCenter: antes de mostrar el formulario, el agente elige si
// va a asegurar un iPhone (flujo actual, por IMEI) u otro dispositivo
// electrónico (flujo nuevo de "appliances", por serial/fabricante).
const DeviceKindSelectComponent = ({ onSelect }: IProps) => {
  const cards: {
    kind: DeviceKind;
    title: string;
    Icon: React.FC<{ className?: string }>;
  }[] = [
    { kind: "phone", title: "iPhone", Icon: IPhoneFlowIcon },
    {
      kind: "appliance",
      title: "Otro dispositivo Apple",
      Icon: MacFlowIcon,
    },
  ];

  return (
    <div className="flex w-full flex-col items-center justify-center bg-transparent px-4">
      <h2 className="mb-4 text-center text-2xl font-bold text-buttonBlack">
        ¿Qué dispositivo vas a asegurar?
      </h2>
      <div className="flex w-full flex-col space-y-4 md:h-96 md:flex-row md:space-x-4 md:space-y-0">
        {cards.map(({ kind, title, Icon }) => (
          <div
            key={kind}
            className="flex min-h-64 w-full flex-1 flex-col items-center justify-center rounded-xl px-4 py-4 md:h-full md:py-2"
          >
            <div className="flex w-full flex-col items-center justify-center">
              <Icon className="my-4 h-28 w-28 md:my-6 md:h-40 md:w-40" />
              <h2 className="text-center text-2xl font-bold text-buttonBlack">
                {title}
              </h2>
            </div>
            <PrimaryButton
              title="Seleccionar"
              type="button"
              className="mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
              onClick={() => onSelect(kind)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeviceKindSelectComponent;
